import React, { useEffect } from "react";

export default function ContactListComponent({ contacts, setContacts }) {
  useEffect(() => {
    return () => {
      setContacts([]);
    };
  }, []);
  return (
    <div className="mt-2">
      {contacts
        ?.filter((contact) => !contact.deleted)
        .map((contact) => (
          <div
            key={contact.id}
            className="me-2 mb-2 d-flex justify-content-between align-items-center w-100 rounded p-2"
            style={{
              fontSize: "0.9rem",
              backgroundColor: "#FFF080",
              color: "#000000",
              border: "1px solid #e0e0e0",
            }}
          >
            <span>{contact.name}</span>
            <button
              type="button"
              className="btn-no-bg text-dark"
              onClick={() => {
                contact.deleted = true;
                setContacts([...contacts]);
              }}
            >
              <i className="icon-close"></i>
            </button>
          </div>
        ))}
    </div>
  );
}
